var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack191({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.75,
    y: 3.83,
    width: 8,
    height: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.7,8.71l.57.08a2.39,2.39,0,0,1-.78,1.13,1.94,1.94,0,0,1-1.16.38,1.63,1.63,0,0,1-1.24-.48,1.88,1.88,0,0,1-.46-1.37,2.72,2.72,0,0,1,.7-1.92,2,2,0,0,1,1.54-.67A1.66,1.66,0,0,1,14,6.22a1.5,1.5,0,0,1,.49,1l-.54,0a1.12,1.12,0,0,0-.35-.7,1,1,0,0,0-.68-.23,1.49,1.49,0,0,0-1.28.7,2.44,2.44,0,0,0-.42,1.43,1.4,1.4,0,0,0,.33,1,1.07,1.07,0,0,0,.84.35,1.22,1.22,0,0,0,.81-.29A1.6,1.6,0,0,0,13.7,8.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack191);
export default __webpack_public_path__ + "static/media/Symbolpack_1_91.a5f6a90f0d4c188203fafa025efccce6.svg";
export { ForwardRef as ReactComponent };